export default "__VITE_ASSET__DagMFmdE__"